import type { ViewsService } from '@/engine/app/Views.service';
import type { ICommand } from '../../core/interfaces/Command';
import type { IRemover } from '@/engine/UIPresentation/Interfaces';
import type { PlanningAlgorithm } from '@/engine/PlanningAlgorithm/PlanningAlgorithm';
import * as DT from '@/engine/PlanningAlgorithm/DataTypes';
import type { IBaseViewModel, IMeasurementViewModel, IObjectViewModel } from '@/engine/app/interfaces';
import type { IIndicationAdder } from '../interfaces';

export class AreaIndicationRemoveCommand implements ICommand {
  private readonly _planningAlgorithm: PlanningAlgorithm;

  private readonly _viewsService: ViewsService;

  private readonly _remover: IRemover;

  private readonly _areaViewModel: IMeasurementViewModel;

  private readonly _splineViewModel: IObjectViewModel;

  private _splineModel: DT.Polyline | undefined;

  private readonly _areaAdder: IIndicationAdder<DT.Polyline>;

  public constructor(
    planningAlgorithm: PlanningAlgorithm,
    viewsService: ViewsService,
    remover: IRemover,
    areaAdder: IIndicationAdder<DT.Polyline>,
    viewModel: IBaseViewModel
  ) {
    this._planningAlgorithm = planningAlgorithm;
    this._viewsService = viewsService;
    this._remover = remover;
    this._areaViewModel = viewModel as IMeasurementViewModel;
    this._areaAdder = areaAdder;

    const splineVM = this._viewsService.currentViewOrThrow.getVmByDescriptor(this._areaViewModel.attachments[0]) as
      | IObjectViewModel
      | undefined;
    if (!splineVM) {
      throw new Error('Spline viewModel of indicated area is undefined');
    }
    this._splineViewModel = splineVM;
  }

  public execute(): Promise<boolean> {
    this._splineModel = this._planningAlgorithm.getValueStrict(this._areaViewModel.attachments[0], DT.Polyline);

    this._remover.removeByDescriptor(this._areaViewModel.descriptor, this._areaViewModel.attachments);
    return Promise.resolve(true);
  }

  public undo(): Promise<boolean> {
    if (!this._splineModel) {
      throw new Error('Model for undo is undefined.');
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises -- //TODO: [chebotarev] fix eslint no-floating-promises
    this._areaAdder.addIndication(this._splineModel, this._areaViewModel, this._splineViewModel);

    return Promise.resolve(false);
  }
}
